import { Pipe, PipeTransform } from '@angular/core';
import {
  FormlySelectOption,
  FormlySelectOptionsPipe,
} from '@ngx-formly/core/select';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { map as rxMap, Observable } from 'rxjs';
import { cloneDeep, defaults, find, map } from 'lodash';
import { concatLatestFrom } from '@ngrx/operators';
import { CastObservablePipe } from '@lockton-apps/shared/ui/pipes';

export interface SelectOption extends FormlySelectOption {
  description?: string;
}

@Pipe({
  name: 'laSelectOptions',
  standalone: true,
})
export class SelectOptionsPipe
  extends FormlySelectOptionsPipe
  implements PipeTransform
{
  constructor(private readonly castObservable: CastObservablePipe) {
    super();
  }

  override transform<TOption = any>(
    options: TOption,
    field?: FormlyFieldConfig
  ): Observable<SelectOption[]> {
    return super.transform(cloneDeep(options), field).pipe(
      concatLatestFrom(() => this.castObservable.transform(options)),
      rxMap(([options, rawOptions]) =>
        map(options, (option) => {
          const rawOption: any = find(rawOptions, {
            value: option.value,
          });

          return defaults(option, { description: rawOption.description || '' });
        })
      )
    );
  }
}
